

export const Globals = {

    //urlBack : 'http://192.168.1.4:3002/hunthireapi' // Servidor local ( Falta el de produccion )

    urlBack : 'https://evbrocks.com/hunthireapi' // Para produccion


}